import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { ArService } from 'src/app/services/ar.service';
import { NotifierService } from 'angular-notifier';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-add-station',
  templateUrl: './add-station.component.html',
  styleUrls: ['./add-station.component.scss']
})
export class AddStationComponent implements OnInit {

  stationForm: FormGroup;
  isEditMode = false;
  formTitle = '';
  submitted = false
  StationData;
  ousourcedConformation = [
    {
      id: 1,
      name : 'Yes',
    },
    {
      id: 0,
      name : 'No',
    }
  ]

  statusTypes = [{
    id: false,
    name: "InActive",
    active: 0
  },
  {
    id: true,
    name: "Active",
    active: 1
  }
  ]

  timezones = [
    { name : "Atlantic Standard Time" },
    { name : "Central Standard Time" },
    { name : "Eastern Standard Time" },
    { name : "Mountain Standard Time" },
    { name : "Pacific Standard Time" },
    { name : "US Mountain Standard Time" }
  ]

  constructor(private notifier: NotifierService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private router: Router,
    public arService: ArService) { }

  ngOnInit() {
    if (this.route.snapshot.paramMap.get('id') != null) {
     // console.log(this.route.snapshot.paramMap.get('id'), 'This is Station Id from URL')
      this.formTitle = "Update Station";
      this.isEditMode = true;
      this.getStationById(this.route.snapshot.paramMap.get('id'));
    } else {
      this.formTitle = "Add Station"
    }
    this.initAddStationForm();
  }

  getStationById(id) {
   // console.log(id, "ID from url")
    this.spinner.show();
    this.arService.getStationDataById(id).subscribe(async sData => {
      this.StationData = sData['result']
      //console.log(this.StationData)     
      this.spinner.hide();
      this.initUpdateStationForm();
    });
  }

  initAddStationForm() {
    // let st = moment().format('MM/DD/YYYY');
    this.stationForm = this.formBuilder.group({
      outSourcedStation: new FormControl('', Validators.compose([Validators.required])),
      stationId: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(6), Validators.pattern('[A-Za-z]{0,6}')])),
      stationCode:new FormControl('', Validators.compose([Validators.required, Validators.maxLength(6), Validators.pattern('[0-9]{0,6}')])),
      address: new FormControl('', Validators.compose([Validators.required])), 
      state: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(2), Validators.pattern('[A-Za-z]{0,2}')])), 
      city: new FormControl('', Validators.compose([Validators.required, Validators.pattern('[A-Za-z ]*')])), 
      zipcode: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(10), Validators.pattern('[0-9A-Za-z ]{0,10}')])),
      country: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(2), Validators.pattern('[A-Za-z]{0,2}')])),
      airportName: new FormControl('', Validators.compose([Validators.required])),
      timeZone: new FormControl('', Validators.compose([Validators.required])),
      active: new FormControl(true, Validators.compose([Validators.required])),
    });
  }

  initUpdateStationForm() {
    this.stationForm = this.formBuilder.group({
      outSourcedStation: new FormControl(this.StationData.OUTSOURCED_STATION, Validators.compose([Validators.required])),
      stationId: new FormControl(this.StationData.stationid, Validators.compose([Validators.required, Validators.maxLength(6), Validators.pattern('[A-Za-z]{0,6}')])),
      stationCode:new FormControl(this.StationData.STATION_CODE, Validators.compose([Validators.required, Validators.maxLength(6), Validators.pattern('[0-9]{0,6}')])),
      address: new FormControl(this.StationData.address, Validators.compose([Validators.required])),
      state: new FormControl(this.StationData.state, Validators.compose([Validators.required, Validators.maxLength(2), Validators.pattern('[A-Za-z]{0,2}')])),
      city: new FormControl(this.StationData.city, Validators.compose([Validators.required, Validators.pattern('[A-Za-z ]*')])),
      zipcode: new FormControl(this.StationData.zipcode, Validators.compose([Validators.required, Validators.maxLength(10), Validators.pattern('[0-9A-Za-z ]{0,10}')])),
      country: new FormControl(this.StationData.country, Validators.compose([Validators.required, Validators.maxLength(2), Validators.pattern('[A-Za-z]{0,2}')])),
      airportName: new FormControl(this.StationData.airportName, Validators.compose([Validators.required])),
      timeZone: new FormControl(this.StationData.timezone, Validators.compose([Validators.required])),
      active: new FormControl(true, Validators.compose([Validators.required])),
      id: new FormControl(this.StationData.id)
    });
  }

  get StationControls() { 
    return this.stationForm.controls; 
  }

  onBack() {
    // this.location.back();
    this.router.navigateByUrl("home/stations");
  }

  validation_messages = {
    'outSourcedStation': [
      { type: 'required', message: 'Outsourced is required.' }
    ],
    'stationId': [
      { type: 'required', message: 'Station is required.' },
      { type: 'maxlength', message: 'Station should be 6 characters long.' },
      { type: 'pattern', message: 'Station must contain alphabets only.' },
    ],
    'stationCode':[
      { type: 'required', message: 'Station Code  is required.' },
      { type: 'maxlength', message: 'Station Code should be 6 characters long.' },
      { type: 'pattern', message: 'Station code must contain numerics only.' },
    ],
    'address': [
      { type: 'required', message: 'Address is required.' }
    ],
    'city': [
      { type: 'required', message: 'City is required.' },
      { type: 'pattern', message: 'City must contain alphabets only.' },
    ],
    'state': [
      { type: 'required', message: 'State is required.' },
      { type: 'maxlength', message: 'State should be 2 characters long.' },
      { type: 'pattern', message: 'State must contain alphabets only.' },
    ],
    'country': [
      { type: 'required', message: 'Country is required.' },
      { type: 'maxlength', message: 'Country should be 2 characters long.' },
      { type: 'pattern', message: 'Country must contain alphabets only.' },
    ],
    'airportName': [
      { type: 'required', message: 'Airport is required.' }
    ],
    'timeZone': [
      { type: 'required', message: 'Time Zone is required.' }
    ],
    'active': [
      { type: 'required', message: 'Status is required.' }
    ],
    'zipcode': [
      { type: 'required', message: 'Zipcode is required.' },
      { type: 'maxlength', message: 'Zipcode should be 10 characters long.' },
      { type: 'pattern', message: 'Zipcode must not contain special characters.' },
    ],
  }

  onAddStation(values) {
    this.submitted = true;
    this.validateStation();
    this.stationForm.markAllAsTouched();
    if (this.stationForm.invalid) {
      return;
    }

    var data = {
      OUTSOURCED_STATION: values.outSourcedStation,
      stationid: values.stationId,
      address: values.address,
      state: values.state,
      city: values.city,
      zipcode: values.zipcode,
      country: values.country,
      airportName: values.airportName,
      timezone: values.timeZone,
      active: values.active,
      startupDate: new Date(),
      allowApi: 0,
      allowBackOffice: 1,
      allowWeb: 0,
      apiConcurrentRes: 3,
      enabled: 1,
      folder: 'RES',
      STATION_CODE : values.stationCode
    }

    this.spinner.show()
    this.arService.addStationsData(data).subscribe(res => {
     // console.log(res)
      if (res['status']) {
        this.spinner.hide();
        this.submitted = false;
        this.notifier.notify('success', res['message']);
        setTimeout(() => {
          this.router.navigateByUrl("home/stations");
        }, 2000);
      } else {
        this.submitted = false;
        this.spinner.hide();
        this.notifier.notify('danger', res['message'])
      }
    }, err => {
      this.notifier.notify('danger', err.message)
      console.log(err);
    })  
    //this.router.navigateByUrl("home/stations");  
  }

  onUpdateStation(values) {
   // console.log(values);
    this.submitted = true
    this.validateStation();
    this.stationForm.markAllAsTouched();
    if (this.stationForm.invalid) {
      return;
    }

    // var data = {
    //   OUTSOURCED_STATION: values.outSourcedStation,
    //   stationid: values.stationId,
    //   id:values.id
    // }

    var data = {
      OUTSOURCED_STATION: values.outSourcedStation,
      stationid: values.stationId,
      address: values.address,
      zipcode: values.zipcode,
      timezone: values.timeZone, 
      id:values.id    
    }

    this.spinner.show();
    this.arService.updateStationData(data).subscribe(res => {
      this.spinner.hide();
      if (res['status']) {
        this.notifier.notify('success', res['message']);
        setTimeout(() => {
          this.router.navigateByUrl("home/stations");
        }, 2000);
      } else {
        this.notifier.notify('danger', res['message'])
      }
    }, err => {
      this.notifier.notify('danger', err.message)
      console.log(err);
    })

  }

  validateStation() {
    //console.log("callingg...");
    if (this.StationControls.stationId.errors) {
      this.notifier.notify('warning', 'Please enter Station');
      return false;
    }
    if (this.StationControls.airportName.errors) {
      this.notifier.notify('warning', 'Please enter Airport ');
      return false;
    }
    if (this.StationControls.timeZone.errors) {
      this.notifier.notify('warning', 'Please select Time Zone ');
      return false;
    }
    if (this.StationControls.address.errors) {
      this.notifier.notify('warning', 'Please enter Address ');
      return false;
    }
    if (this.StationControls.city.errors) {
      this.notifier.notify('warning', 'Please enter City');
      return false;
    }
    if (this.StationControls.state.errors) {
      this.notifier.notify('warning', 'Please enter State');
      return false;
    }
    if (this.StationControls.zipcode.errors) {
      this.notifier.notify('warning', 'Please enter Zipcode ');
      return false;
    }
    if (this.StationControls.country.errors) {
      this.notifier.notify('warning', 'Please enter Country');
      return false;
    }
    if (this.StationControls.outSourcedStation.errors) {
      this.notifier.notify('warning', 'Please select Outsourced ');
      return false;
    }
  }

}
